<template>
  <div class="drawer-container">
    <div>
      <h2 class="drawer-title">界面设置</h2>
      <el-divider></el-divider>
      <div class="drawer-item" @click="toDoClick()">
        <span>待办:</span>
        <el-switch
          v-model="toDoShow"
          class="drawer-switch"
          active-color="#00B259"
          inactive-color="#9DA5B2"
        ></el-switch>
      </div>
      <div class="drawer-item">
        <span>报警:</span>
        <el-switch
          v-model="warnshow"
          class="drawer-switch"
          active-color="#00B259"
          inactive-color="#9DA5B2"
          @change="warnClick()"
        ></el-switch>
      </div>
      <div class="drawer-item">
        <span>消息:</span>
        <el-switch
          v-model="messageShow"
          class="drawer-switch"
          active-color="#00B259"
          inactive-color="#9DA5B2"
          @change="messageClick()"
        ></el-switch>
      </div>
      <el-divider></el-divider>
      <div class="drawer-item">
        <h3 style="margin-bottom: 15px">语言切换</h3>
        <el-radio-group v-model="lang" @change="handleChangeLang()">
          <el-radio label="en">英文</el-radio>
          <el-radio label="zh">中文</el-radio>
        </el-radio-group>
      </div>
      <el-divider></el-divider>
      <div class="drawer-item">
        <h3 style="margin-bottom: 15px">字体大小</h3>
        <el-radio-group v-model="radio2" @change="handleSetSize">
          <el-radio label="default">默认</el-radio>
          <el-radio label="medium">大字</el-radio>
          <el-radio label="small">中等</el-radio>
          <el-radio label="mini">细小</el-radio>
        </el-radio-group>
      </div>
      <el-divider></el-divider>
      <div class="drawer-item">
        <h3 style="margin-bottom: 15px">引导</h3>
        <el-radio-group v-model="tagsView">
          <el-radio :label="false">面包屑</el-radio>
          <el-radio :label="true">页签</el-radio>
        </el-radio-group>
      </div>
      <el-divider></el-divider>
      <div class="drawer-item">
        <span>换肤</span>
        <theme-picker
          style="float: right; height: 26px; margin: -3px 8px 0 0"
          @change="themeChange"
        />
        <!--<button @click="switchTheme('green')">green</button>
        <button @click="switchTheme('blue')">blue</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import ThemePicker from "@/components/common/ThemePicker";
import { getLang } from "@/utils/auth";

/* import { generateTitle } from "@/utils/i18n";*/
import { mapState } from "vuex";
import { application } from "@/api/other/sysManage";

/*
 * function initSetting() {
 *   return {
 *
 *   };
 * }
 */
export default {
  components: { ThemePicker },
  data() {
    return {
      toDo: true,
      warning: true,
      message: true,
      value4: true,
      radio1: 1,
      radio2: "default",
      lang: getLang(),
      theme: [{ value: "red", label: "Red" },
        { value: "blue", label: "Blue" },
        { value: "green", label: "Green" }],
      value: "",
      themeName: "green"
    };
  },
  watch: {
    themeName(newThemeName, oldThemeName) {
      document.body.classList.toggle(oldThemeName);
      document.body.classList.toggle(newThemeName);
    }
  },
  computed: {
    ...mapState({
      toDoShow: state => state.settings.toDoShow,
      warnshow: state => state.settings.warnshow,
      messageShow: state => state.settings.messageShow
    }),
    tagsView: {
      get() {
        return this.$store.state.settings.tagsView;
      },
      set(val) {
        const setting = [
          this.toDoShow ? "toDoShow" : null,
          this.warnshow ? "warnshow" : null,
          this.messageShow ? "messageShow" : null,
          !this.tagsView ? "tagsView" : null,
          this.lang
        ];
        // 调用后台保存数据
        application.saveUserSetting({ labelShow: setting }).then(res => {
          if (res.code === 200) {
            this.$store.dispatch("settings/changeSetting", {
              key: "tagsView",
              value: val
            });
          }
        });
      }
    },
    sidebarLogo: {
      get() {
        return this.$store.state.settings.sidebarLogo;
      },
      set(val) {}
    },
    size() {
      return this.$store.getters.size;
    }
  },

  methods: {

    /* generateTitle,*/
    handleChangeLang() {
      const setting = [
        !this.toDoShow ? "toDoShow" : null,
        this.warnshow ? "warnshow" : null,
        this.messageShow ? "messageShow" : null,
        this.tagsView ? "tagsView" : null,
        this.lang
      ];
      application.saveUserSetting({ labelShow: setting }).then(res => {
        if (res.code === 200) {
          this.$store.commit("settings/CHANGE_LANG", this.lang);
          location.reload();
        }
      });
    },
    themeChange(val) {
      const setting = [
        this.toDoShow ? "toDoShow" : null,
        this.warnshow ? "warnshow" : null,
        this.messageShow ? "messageShow" : null,
        this.tagsView ? "tagsView" : null,
        this.lang,
        val
      ];
      application.saveUserSetting({ labelShow: setting }).then(res => {
        if (res.code === 200) {
          this.$store.dispatch("settings/changeSetting", {
            key: "theme",
            value: val
          });
        }
      });
    },
    switchTheme(theme) {
      this.themeName = theme;
    },
    handleSetSize(size) {
      this.$ELEMENT.size = size;
      this.$store.dispatch("app/setSize", size);
      this.refreshView();
      this.$message({
        message: "切换布局操作成功",
        type: "success"
      });
    },
    refreshView() {
      // In order to make the cached page re-rendered
      this.$store.dispatch("tagsView/delAllCachedViews", this.$route);
      const { fullPath } = this.$route;
      this.$nextTick(() => {
        this.$router.replace({
          path: `/redirect${fullPath}`
        });
      });
    },
    toDoClick() {
      const setting = [
        !this.toDoShow ? "toDoShow" : null,
        this.warnshow ? "warnshow" : null,
        this.messageShow ? "messageShow" : null,
        this.tagsView ? "tagsView" : null,
        this.lang
      ];
      // 调用后台保存数据
      application.saveUserSetting({ labelShow: setting }).then(res => {
        if (res.code === 200) {
          const val = !this.toDoShow;
          this.$store.dispatch("settings/changeSetting", {
            key: "toDoShow",
            value: val
          });
        }
      });
    },
    warnClick() {
      const setting = [
        this.toDoShow ? "toDoShow" : null,
        !this.warnshow ? "warnshow" : null,
        this.messageShow ? "messageShow" : null,
        this.tagsView ? "tagsView" : null,
        this.lang
      ];
      application.saveUserSetting({ labelShow: setting }).then(res => {
        if (res.code === 200) {
          const val = !this.warnshow;
          this.$store.dispatch("settings/changeSetting", {
            key: "warnshow",
            value: val
          });
        }
      });
    },
    messageClick() {
      const setting = [
        this.toDoShow ? "toDoShow" : null,
        this.warnshow ? "warnshow" : null,
        !this.messageShow ? "messageShow" : null,
        this.tagsView ? "tagsView" : null,
        this.lang
      ];
      application.saveUserSetting({ labelShow: setting }).then(res => {
        if (res.code === 200) {
          const val = !this.messageShow;
          this.$store.dispatch("settings/changeSetting", {
            key: "messageShow",
            value: val
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-container {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
  }

  .drawer-item {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    padding: 12px 0;
  }

  .drawer-switch {
    float: right;
  }
  .switch-item {
    display: flex;
    justify-content: space-between;
  }

  ::v-deep .el-switch {
    .el-switch__core {
      width: 40px !important;
      height: 20px;
      background: #9da5b2;
      transition: background-color 0.3s;

      &::after {
        top: 1px;
        left: 0px;
        width: 16px;
        height: 16px;
        background: #f9f9fb;
        transition: all 0.3s;
      }
    }

    .el-switch__label--left {
      color: #505363;
    }

    .el-switch__label--right {
      display: none;
    }

    &.is-checked {
      .el-switch__core {
        background: #a9e2c5;
        border: none;

        &::after {
          top: 1px;
          left: 40px;
          width: 16px;
          height: 16px;
          background: #f9f9fb;
          transition: all 0.3s;
        }
      }

      .el-switch__label--left {
        color: #505363;
      }

      .el-switch__label--right {
        z-index: 99;
        display: inline-block;
        margin-left: -32px;
        color: #fff;

        i {
          font-size: 8px;
        }
      }
    }
  }
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 6px 0;
}
.el-radio {
  color: #505363;
  font-weight: 500;
  line-height: 1;
  position: relative;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  outline: 0;
  font-size: 14px;
  margin-right: 8px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>
